import React from 'react';
import { useDispatch } from 'react-redux';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

import { Colors } from '../themes/colors';
import { showMessage } from '../actions';
import Button from './Button';

const CheckoutForm = (props) => {
  const dispatch = useDispatch();

  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    stripe
      .createToken(cardElement)
      .then((resToken) => {
        props.result(resToken);
      })
      .catch((err) => {
        dispatch(showMessage({ title: 'Error', message: err, isError: true }));
      });
  };

  const CARD_OPTIONS = {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#c4f0ff',
        color: '#424770',
        fontSize: '20px',
        fontSmoothing: 'antialiased',
        ':-webkit-autofill': {
          color: '#fce883',
        },
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        iconColor: Colors.error_500,
        color: Colors.error_500,
      },
    },
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        minWidth: 500,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginTop: 30,
      }}
    >
      <CardElement options={CARD_OPTIONS} />
      <div style={{ marginLeft: 120, marginTop: 10 }}>
        <Button
          text="Submit"
          onClick={(e) => handleSubmit(e)}
        />
      </div>
    </form>
  );
};
export default CheckoutForm;
